import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

const params = new URLSearchParams(window.location.search);
let mobile = false;
if (params.get('mobile')) {
  mobile = true;
}

/**
 * @typedef {object} ContestCardProps
 * @property {string} title The title to display on the card
 * @property {string} description The description to display on the card
 */

/**
 * ContestCard
 *
 * @param {ContestCardProps} props Props
 * @returns {JSX.Element} ContestCard
 */

const ContestCard = ({ title = '', description = '', terms = '' }) => (
  <div className="contest">
    <Link to="/main/rewards/dashboard">
      <h3>{title}</h3>
    </Link>
    <div className="details">
      <div>
        <p
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        {!mobile && <p>
          <span className="terms" role="button" tabIndex={0} data-fancybox="terms" data-type="iframe" href={terms}>
            <p>{i18n.translate('rewards.home.ContestTerms')}</p>
          </span>
        </p>}
         {mobile && <p>
          <a onClick={() => window.ReactNativeWebView.postMessage(`webview:${terms}`)} className="terms" role="button" tabIndex={0}>
            <p>{i18n.translate('rewards.home.ContestTerms')}</p>
          </a>
        </p>}
      </div>
    </div>
  </div>
);

ContestCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  terms: PropTypes.string,
};

export default ContestCard;
